"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationRules = void 0;
const react_1 = require("react");
const notification_context_1 = require("../notification/notification-context");
const list_source_hook_1 = require("../../utils/list-source-hook");
function useNotificationRules() {
    const { ruleUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${ruleUrl}/list`,
        method: 'GET',
    });
}
exports.useNotificationRules = useNotificationRules;
//# sourceMappingURL=notification-template-api.js.map